export let SelectionMode = {
    LEAF_OBJECT : 0,
    FIRST_OBJECT : 1,
    LAST_OBJECT : 2
};
